import "core-js/modules/es.array.push.js";
import { defineComponent } from "vue";
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
import { useRouter } from "vue-router";
import { useStore } from "vuex";
export default defineComponent({
  components: {
    ElConfigProvider
  },

  setup() {
    const getUrlCode = () => {
      var url = location.search;
      var theRequest = new Object();

      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");

        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }

      return theRequest;
    };

    const getCode = () => {
      const code = getUrlCode().code; // 截取code

      var local = window.location.href; // 获取页面url

      var appid = 'wxc22581afc1ce69b8';

      if (code === undefined || code === null || code === '') {
        // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
      } else {
        sessionStorage.setItem('code', code);
        isLogin();
      }
    };

    const isWeixin = () => {
      let ua = navigator.userAgent.toLowerCase();
      return ua.indexOf('micromessenger') !== -1;
    };

    const isLogin = () => {
      const user = localStorage.getItem('user');

      if (!user) {
        const router = useRouter();
        router.push('login');
      } else {
        const {
          commit
        } = useStore();
        commit('user/setUser', JSON.parse(user));
      }
    };

    const {
      state
    } = useStore();

    if (isWeixin()) {
      getCode();
      state.appData.isWeixin = true;
    } else {
      isLogin();
      state.appData.isWeixin = false;
    }

    return {
      locale: zhCn
    };
  }

});